import React, { useContext, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import sample from 'lodash/sample';

import { GlobalState } from '../../store';

import Cursor from '../Cursor';
import Info from '../Info';
import WebsiteIndex from '../WebsiteIndex';
import HomeButton from '../HomeButton';

// import './reset.css';
import { GlobalStyle, Wrapper, Content } from './style';

const Layout = ({ location, pageContext, children }) => {
  const { allColourPalettes, colourPalette, intro, metaData, pages, websites } = pageContext;
  const indexColourPalette = useRef(sample(allColourPalettes))
  const palette = colourPalette || indexColourPalette.current

  const pageSlugs = pages.map(page => page.slug);
  const websiteSlugs = websites.map(website => website.slug);
  const activeSlug = location.pathname.replace('/', '');

  const globalStateDispatch = useContext(GlobalState.Dispatch);

  globalStateDispatch({
    type: 'setTheme',
    theme: {
      backgroundColor: palette.background,
      foregroundColor: palette.foreground,
    },
  });

  return (
    <Wrapper>
      <GlobalStyle
        backgroundColor={palette.background}
        foregroundColor={palette.foreground}
      />
      <Helmet>
        <title>{`${metaData.metaTitle} | ${metaData.siteName}`}</title>
        <meta name="description" content={metaData.metaDescription} />
        <meta name="keywords" content={metaData.metaKeywords} />
        {metaData.favicon ? (
          <link
            rel="shortcut icon"
            href={`${metaData.favicon.fixed.src}&r=max`}
          />
        ) : null}

        <meta property="og:site_name" content={metaData.siteName} />
        <meta property="og:title" content={metaData.metaTitle} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={metaData.metaDescription} />
        {metaData.metaImage ? (
          <meta property="og:image" content={metaData.metaImage.fluid.src} />
        ) : null}
      </Helmet>
      <Content>
        <HomeButton isActive={!!activeSlug} />
        <Info
          activeSlug={activeSlug}
          isActive={
            activeSlug.length > 0 && pageSlugs.indexOf(activeSlug) !== -1
          }
          isInactive={
            activeSlug.length > 0 && pageSlugs.indexOf(activeSlug) === -1
          }
          intro={intro}
          pages={pages}
        />
        <WebsiteIndex
          activeSlug={activeSlug}
          isActive={
            activeSlug.length > 0 && websiteSlugs.indexOf(activeSlug) !== -1
          }
          isInactive={
            activeSlug.length > 0 && websiteSlugs.indexOf(activeSlug) === -1
          }
          websites={websites}
        />
      </Content>
      {children}
      <Cursor />
    </Wrapper>
  );
};

export default Layout;
